export enum Platform {
  PC = "PC",
  PlayStation = "PS",
  Xbox = "Xbox",
}
